import { ReactNode } from 'react';
import styled from 'styled-components';

import { typographyClassName } from '@creditornot/cb-ingredients';
import { clsx } from '@creditornot/cb-utils';

const variantMap = {
  display: typographyClassName.display,
  largeTitle: typographyClassName.largeTitle,
  title: typographyClassName.title,
  headline: typographyClassName.headline,
  subheadline: typographyClassName.subheadline,
} as const;

type Variant = keyof typeof variantMap;

type Props = {
  children: ReactNode;
  className?: string;
  level: 1 | 2 | 3 | 4 | 5 | 6;
  variant: Variant;
};

const StyledHeading = styled.h1`
  margin: 0;
`;

export function Heading({ children, className, level, variant, ...props }: Props) {
  return (
    <StyledHeading {...props} as={`h${level}`} className={clsx(variantMap[variant], className)}>
      {children}
    </StyledHeading>
  );
}
